$('.come-fare-wrapper .button-02').on('click',function(){
	$('.come-fare-wrapper .img-02').addClass('show');
	$('.come-fare-wrapper .img-01').addClass('hide');
});


$('.come-fare-wrapper .button-01').on('click',function(){
	$('.come-fare-wrapper .img-02').removeClass('show');
	$('.come-fare-wrapper .img-01').removeClass('hide');
});
